<template>
  <v-container>
      <v-btn @click="fetchAPI" color="success">Betaal</v-btn>
      {{response}}
      <canvas id="canvas"></canvas>
      </v-container>
</template>

<script>

import {config} from '../config/config'
import QRCode from 'qrcode'
export default {
  name: "createPayment",
  data() {
    return {
        response: ""
    }
  },
  methods: {
    async fetchAPI() {
      let res = await fetch(`${config.api.host}/payments/createPayment`, {
        method: "GET",
        headers: { "Content-Type": "application/json" }
      })
    let response = await res.json()
    console.log(response)
    this.response= response
    let canvas = document.getElementById("canvas")
     await QRCode.toDataURL(canvas,response)
    window.location.replace(response)
    },
    async toDataURL(src) {
    var image = new Image();
    image.crossOrigin = 'Anonymous';
    let promise = new Promise((resolve, reject) => {
        try {
            image.onload = function image() {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                canvas.height = this.naturalHeight;
                canvas.width = this.naturalWidth;
                context.drawImage(this, 0, 0);
                var dataURL = canvas.toDataURL('image/png');
                resolve(dataURL)
            }
        }
        catch (e) {
            reject()
            console.log(e)
        }
    })
    image.src = src
    return promise
}
  }
}
</script>

<style>
</style>